import { useEffect, useState, useContext } from "react";
import { loadCase } from "../data/loadCase";
import CaseCard from "./CaseCard";
import UnderlineSketch from "./UnderlineSketch";
import { NameContext } from "../context/NameContext";

export default function CaseListCase({ currentSlug, max = 3 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { name } = useContext(NameContext);

  useEffect(() => {
    loadCase().then((data) => {
      const filtered = data.filter(post => post.slug !== currentSlug);
      setPosts(filtered);
      setLoading(false);
    });
  }, [currentSlug]);

 if (loading)
  return (
    <div className="py-10 text-center font-mono text-xs text-gray-500">
      Lade weitere CaseStudies…
    </div>
  );

if (!posts.length) return null;

  return (
    <div className="mt-16 p-4 max-w-4xl mx-auto">
      <div className="py-10">
        <UnderlineSketch />
      </div>
      <h3 className="font-mono text-xs text-gray-700 mb-6 text-center sm:text-left">
        Weitere Beiträge für dich {name}
      </h3>
      <div className="grid gap-6 sm:grid-cols-2">
        {posts.slice(0, max).map(post => (
          <CaseCard post={post} key={post.slug} />
        ))}
      </div>
      <div className="py-10">
        <UnderlineSketch />
      </div>
    </div>
  );
}